import Toast, { showToast } from './Toast';

export { showToast };

export default Toast;
